import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.instructions-scim', {
        url: '/instructions-scim',
        component: 'companyDirectoryIntegrationManageInstructionsScim',
        resolve: {
        },
    });
}




// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/scim/instructions/directory-integration-instructions-scim.state.js